// Repetição automática de requisições que receberam 503 "servidor ocupado"
// (limite de requisições simultâneas do backend, app/core/concurrency_limit.py,
// ou proxy sem backend por instantes). Ver R270 em docs/07-issues.md.
//
// Só repete o que é seguro repetir: GET/HEAD/OPTIONS, ou requisição marcada
// com `retryOn503: true` na config do axios (ex.: check-in, que manda
// idempotency_key e o backend descarta a duplicata). POST/PUT/PATCH/DELETE
// comuns nunca são repetidos: poderiam gravar duas vezes.

export const MAX_RETRIES_503 = 2;
const MAX_DELAY_MS = 5000;
const DEFAULT_DELAY_MS = 1500;
const SAFE_METHODS = ["get", "head", "options"];

export function shouldRetry503(error) {
  const config = error?.config;
  if (!config || error?.response?.status !== 503) return false;
  const method = (config.method || "get").toLowerCase();
  if (!SAFE_METHODS.includes(method) && !config.retryOn503) return false;
  return (config._retry503Count || 0) < MAX_RETRIES_503;
}

// Retry-After em segundos (o backend manda 2), limitado a 5s pra tela não
// parecer travada; sem o cabeçalho, 1,5s. Um pouco de variação evita que
// todos os aparelhos voltem no mesmo instante.
export function retryDelayMs(error, random = Math.random) {
  const header = error?.response?.headers?.["retry-after"];
  const seconds = Number.parseFloat(header);
  const base = Number.isFinite(seconds) && seconds >= 0 ? seconds * 1000 : DEFAULT_DELAY_MS;
  return Math.min(base, MAX_DELAY_MS) + Math.round(random() * 500);
}
